Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "ScrollableTabs2393330412",
  {"root":"ScrollableTabs2393330412--root","nav":"ScrollableTabs2393330412--nav","tab":"ScrollableTabs2393330412--tab","selectedIndicator":"ScrollableTabs2393330412--selectedIndicator","border":"ScrollableTabs2393330412--border","itemsList":"ScrollableTabs2393330412--itemsList","scrollAnimationDuration":".4s","selectedIndicatorColor":"--overridable"},
  "",
  2,
  "ScrollableTabs2393330412"
);

